import { SystemListCollectionModel } from "@iewcasia/Types/CustomApiModels";
import { ApiParameter, doesNotHaveExpand, get, post } from "@insite/client-framework/Services/ApiService";
import { GetOrderApiParameter } from "@insite/client-framework/Services/OrderService";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";

const baseV1 = "/api/v1";

export interface GetSystemListApiParameter extends ApiParameter {
    namelist?: string;
}

export function getSystemList(parameter: GetSystemListApiParameter) {
    return get<SystemListCollectionModel>(`${baseV1}/customlist/list`, parameter);
}

export function getCustomOrder(parameter: GetOrderApiParameter): Promise<OrderModel> {
    const { orderNumber, ...newParameter } = parameter;

    return get<OrderModel>(`${baseV1}/customorders/${orderNumber}`, newParameter);
}

function cleanOrderFieldNewLine(field: string) {
  // \r\n = CR + LF → Used as a new line character in Windows
  // \r = CR (Carriage Return) → Used as a new line character in Mac OS before X
  // \n = LF (Line Feed) → Used as a new line character in Unix/Mac OS X
  return (field ?? '').trim().replace(/\r\n/gi, "").replace(/\r/gi, "").replace(/\n/gi, "");
}

function cleanOrder(orderModel: any, parameter?: { expand?: string[]; additionalExpands?: string[] }) {
  orderModel.guid = orderModel.id;
  orderModel.orderDate = new Date(orderModel.orderDate);
  orderModel.id = cleanOrderFieldNewLine(orderModel.erpOrderNumber || orderModel.webOrderNumber);

  orderModel.orderLines?.forEach((orderLine: any) => {
    if (orderLine.product) {
      orderLine.productInfo = JSON.parse(JSON.stringify(orderLine.product));
      delete orderLine.product;
    }
  });

  if (doesNotHaveExpand(parameter, "orderLines")) {
      delete orderModel.orderLines;
  }

  if (!orderModel.shipViaDescription) {
      delete orderModel.shipViaDescription;
  }
}

const customOrdersUrl = "/api/v1/customorders";

export async function getOrderForOrderStatus(parameter: GetOrderApiParameter): Promise<OrderModel> {
  const { orderNumber, ...newParameter } = parameter;
  const customOrder = await get<OrderModel>(`${customOrdersUrl}/${orderNumber}`, newParameter);

  cleanOrder(customOrder, parameter);
  return customOrder;
}

export function getPdf(parameter: any): Promise<string> {
  return post<any>(`${baseV1}/downloadcustomerdocuments/getpdf`, parameter);
}

export function getPackingList(parameter: any): Promise<string> {
  return get<any>(`${baseV1}/packinglist/${parameter.orderNumber}`);
}

export function getOrderInvoices(parameter: any): Promise<string> {
  return get<any>(`${baseV1}/custominvoices`, {
    customerNumber: parameter.customerNumber,
    customerSequence: -1,
    fromDate: '',
    orderNumber: parameter.orderNumber,
    page: 1,
    pageSize: 1000,
    sort: 'InvoiceDate DESC',
  } as any);
}
